import { render, staticRenderFns } from "./ComboboxChips.vue?vue&type=template&id=65da94bf&scoped=true"
import script from "./ComboboxChips.vue?vue&type=script&lang=js"
export * from "./ComboboxChips.vue?vue&type=script&lang=js"
import style0 from "./ComboboxChips.vue?vue&type=style&index=0&id=65da94bf&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da94bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VCombobox,VListItem,VListItemContent,VListItemTitle})
